const IFRAME_RE = /<iframe\b[\s\S]*?<\/iframe>/gi;

function htmlBooleanAttr(value) {
  if(value === undefined || value === null) return undefined;
  return value !== false && value !== 'false';
}

/**
 * react-showdown forwards raw HTML attrs onto React elements. CMS Vimeo embeds
 * use allowfullscreen / frameborder, which React warns about.
 */
export function toReactIframeProps(props) {
  if(!props) return {};

  const {
    allowfullscreen,
    allowFullScreen,
    frameborder,
    frameBorder,
    marginwidth,
    marginWidth,
    marginheight,
    marginHeight,
    ...rest
  } = props;

  return {
    ...rest,
    allowFullScreen: htmlBooleanAttr(allowFullScreen ?? allowfullscreen),
    frameBorder: frameBorder ?? frameborder,
    marginWidth: marginWidth ?? marginwidth,
    marginHeight: marginHeight ?? marginheight,
  };
}

/**
 * Wrap CMS iframes (Vimeo, etc.) in the existing 16:9 box so a 640px embed
 * cannot overflow a narrower feature pane or mobile sheet.
 */
export function wrapMarkdownIframes(markup) {
  if(!markup || typeof markup !== 'string') return markup;

  return markup.replace(IFRAME_RE, (iframe, offset) => {
    const prefix = markup.slice(Math.max(0, offset - 32), offset);
    if(/<div class="d-16-9">\s*$/.test(prefix)) return iframe;
    return `<div class="d-16-9">${iframe}</div>`;
  });
}
